import {BaseEventConfig} from "./base-event-config";
import {BaseModel} from "../models/base-model";
import {ANALYTICS} from "../../third-party-services/analytics/analytics-consts";
import {Type} from "../type";
import {BaseRouteConfig} from "../../core/components/router/models/base-route-config";
import {BaseTerms} from "../models/base-terms";
import {BaseRemoteConfiguration} from "../models/base-remote-configuration";

export class BaseConfig extends BaseModel {
  name: String;
  routeConfig: BaseRouteConfig;
  terms: Object;
  remoteConfig: BaseRemoteConfiguration;
  events: Array<BaseEventConfig>;
  entityType: Type;

  static injectables = [];

  constructor(name: String = '', routeConfig: Type<BaseRouteConfig> = null, terms: Type<BaseTerms> = BaseTerms, remoteConfig: BaseRemoteConfiguration, events = [], entityType: Type) {
    super();

    this.name = name;
    this.routeConfig = routeConfig;
    this.terms = terms;
    this.remoteConfig = remoteConfig;
    this.events = events || [];
    this.entityType = entityType;
  }

  get displayEvent(): BaseEventConfig {
    return this.events.find((event: BaseEventConfig) => event.type === ANALYTICS.EVENT_TYPES.display);
  }

  getValue(config) {
    return this.remoteConfig?.getValue(config) ?? config.default
  }
}
